import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

export default class Navbar extends Component {
  render() {
    return (
      <nav id="navbar-menu" className="navbar navbar-expand-lg bg-white">
        <div className="container-fluid">
          <Link to="./" className="navbar-brand">
            <img
              src="https://participacion-ciudadana.itetlax.org.mx/assets/img/participacionCiudadana.png"
              alt="Micrositio Participación Ciudadana"
              className="img-fluid Navbar__logoITE"
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-center"
            id="navbarNav"
          >
            <ul className="navbar-nav">

              {/* INICIO */}
              <li className="nav-item">
                <Link to="./" className="nav-link">
                  Inicio
                </Link>
              </li>

              {/* MECANISMOS (mejorado para Bootstrap) */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownMecanismos"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Mecanismos
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdownMecanismos"
                >
                  {/* <li>
                    <Link to="./IniciativaPopular" className="dropdown-item">
                      Iniciativa Popular
                    </Link>
                  </li> */}
                  <li>
                    <Link to="./ConsultaPopular" className="dropdown-item">
                      Consulta Popular
                    </Link>
                  </li>
                  <li>
                    <Link to="./Plebiscito" className="dropdown-item">
                      Plebiscito
                    </Link>
                  </li>
                  <li>
                    <Link to="./Referendum" className="dropdown-item">
                      Referéndum
                    </Link>
                  </li>
                  <li>
                    <Link to="./VozCiudadana" className="dropdown-item">
                      Voz Ciudadana en el Cabildo
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link to="./Infografias" className="nav-link">
                  Infografías
                </Link>
              </li>

              {/* ESTUDIOS (DROPDOWN) */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownEstudios"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Estudios
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdownEstudios"
                >
                  <li>
                    <a
                      href="https://participacion-ciudadana.itetlax.org.mx/assets/pdf/ESTUDIO%20DE%20PARTICIPACI%C3%93N%20CIUDADANA%202020-2021.pdf"
                      className="dropdown-item"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ESTUDIO DE PARTICIPACIÓN CIUDADANA 2020-2021
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://itetlax.org.mx/assets/pdf/informes/libro/11.pdf"
                      className="dropdown-item"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Estudio Muestral sobre la participación ciudadana PELO 2015-2016 (PDF)
                    </a>
                  </li>
                  <li>
                    <a
                      /* href="https://participacion-ciudadana.itetlax.org.mx/assets/pdf/Estudio_Participacion.pdf" */
                      className="dropdown-item"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                     Estudio de Participación Ciudadana del Proceso Electoral Local Ordinario 2023-2024
                    </a>
                  </li>
                  <li>
                    <a
                      /* href="https://participacion-ciudadana.itetlax.org.mx/assets/pdf/Informe_Resultados.pdf" */
                      className="dropdown-item"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Informe de Resultados de la Encuesta sobre la Percepción de las Juventudes Tlaxcaltecas Respecto de los Procesos Electorales
                    </a>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link to="./Convenios" className="nav-link disabled">
                  Convenios
                </Link>
              </li>

              {/* EVENTOS */}
              <li className="nav-item">
                <Link to="./Eventos" className="nav-link ">
                  Eventos
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
